import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcMinimize(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.262 20v-4.201L4.03 21.03a.75.75 0 1 1-1.06-1.06l5.22-5.22H4.011a.75.75 0 1 1 0-1.5h6a.75.75 0 0 1 .75.75v6a.75.75 0 1 1-1.5 0m10.72-17.03a.75.75 0 1 1 1.06 1.06l-5.22 5.22H20a.75.75 0 1 1 0 1.5h-6a.75.75 0 0 1-.75-.75V4a.75.75 0 0 1 1.5 0V8.2z"
  }));
}
var IcMinimize = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMinimize));

export { IcMinimize as I };
